export enum RepresentativeRole {
  PRESIDENT = 'PRESIDENT',
  MANAGING_DIRECTOR = 'MANAGING_DIRECTOR', // Directeur général
  COMPANY_MANAGER = 'COMPANY_MANAGER', // Gérant
  SHAREHOLDER = 'SHAREHOLDER', // Actionnaire
  SIGNER = 'SIGNER',
  VIEWER = 'VIEWER',
  CREATOR = 'CREATOR',
}
